import {
  BookSelectorValue,
  BooksSelector,
} from 'components/forms/book-selector';
import {
  EventSelector,
  EventSelectorValue,
} from 'components/forms/event-selector';
import { EditorState } from 'draft-js';
import { useInput } from 'lib/hooks/use-input';
import { useHasClickedOutside } from 'lib/hooks/use-has-clicked-outside';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { constants, getEntityIfSelected } from '../editor-utils';
import { CreateLink } from './link';

interface EventComponentProps {
  editorState: EditorState;
  setEditorState: Dispatch<SetStateAction<EditorState>>;
}
export const EventComponent = ({
  editorState,
  setEditorState,
}: EventComponentProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const event = useInput<EventSelectorValue[]>([]);
  const ref = useRef(null);
  const hasClickedOutside = useHasClickedOutside(ref);
  const alreadyHasEvent = getEntityIfSelected(
    constants.EntityTypes.LINK,
    editorState
  );

  useEffect(() => {
    if (showModal && hasClickedOutside) {
      setShowModal(false);
      event.init([]);
    }
  });

  const handleCreateEvent = () => {
    CreateLink(
      editorState,
      setEditorState,
      `/events/${event.value[0].data.slug}`,
      'event'
    );
    setShowModal(false);
    event.init([]);
  };

  return (
    <>
      <div className='relative flex'>
        <button
          title='link'
          aria-label='link'
          className='bg-white hover:bg-gray-400 text-gray-800 font-semibold px-2 rounded disabled:text-gray-400'
          onClick={(e) => {
            e.preventDefault();
            setShowModal(true);
          }}
          disabled={!!alreadyHasEvent}>
          <svg
            className='w-5 h-6'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 20 20'
            fill='currentColor'>
            <g fill='none' fillRule='evenodd'>
              <path
                d='M4.5 2.5h12a2 2 0 012 2v11.99a2 2 0 01-2 2h-12a2 2 0 01-2-2V4.5a2 2 0 012-2zM2.659 6.5H18.5'
                stroke='#2a2e3b'
                strokeWidth={2}
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                strokeWidth={2}
                d='M6.816 13.155v-1.079h.88c.668 0 1.122-.395 1.122-.972 0-.527-.415-.927-1.103-.927-.713 0-1.152.366-1.201.996H5.15C5.201 9.874 6.201 9 7.788 9c1.563 0 2.432.864 2.427 1.895-.005.854-.542 1.416-1.299 1.601v.093c.981.141 1.577.766 1.577 1.709 0 1.235-1.162 2.11-2.754 2.11S5.063 15.537 5 14.204h1.411c.044.596.552.977 1.309.977.747 0 1.27-.406 1.27-1.016 0-.625-.489-1.01-1.28-1.01zm6.695 3.072v-5.61h-.088l-1.729 1.19v-1.371l1.822-1.255h1.47v7.046z'
                fill='currentColor'
              />
            </g>
          </svg>
        </button>
        {showModal && (
          <div
            ref={ref}
            className='z-10  absolute right-0 mt-8 rounded-md  ring-1 ring-black ring-opacity-5 [ bg-white border border-gray-100 shadow-lg sm:rounded-lg px-1 py-2 sm:px-2 space-x-2 flex flex-row ] '>
            <EventSelector value={event.value} setValue={event.setValue} />
            <div className='flex rounded-md shadow-sm'>
              <button
                type='button'
                className='relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:cursor-not-allowed disabled:text-gray-500'
                onClick={handleCreateEvent}
                disabled={!event.isModified}>
                <span>Link</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
